(function() {
    'use strict';
    angular
        .module('quantixApp')
        .controller('CustomTemplateLevelTwoController', CustomTemplateLevelTwoController);
    CustomTemplateLevelTwoController.$inject = ['$scope', '$filter', 'CompanyReportService', '$window', '$state', '$timeout'];
    function CustomTemplateLevelTwoController($scope, $filter, CompanyReportService, $window, $state, $timeout) {
        
        $scope.templateJson = $state.params.templateJson ? $state.params.templateJson : $state.go('createnewtemplate');
        $scope.action = $state.params.action;
        $scope.createdOn = $state.params.createdOn;
        $scope.restrictions = $state.params.restrictions;
        $scope.templateJson.createdOn = $scope.createdOn;
        $scope.isAdminEdit = $state.params.isAdminEdit;
        $scope.defaultJson = JSON.parse(localStorage.getItem('defJson'));
        $scope.formMessage = '';
        $scope.sharePriceVolumes = {
            fiveDay : false,
            oneMon : false,
            sixMon : false,
            oneYr : false,
            twoYr : false,
            fiveYr : false
        }
        $scope.message = '';
        $scope.data = {
            selectedOption:'manu'
        };
        $scope.manuDataPoints = ['revenue', 'operatingIncome', 'adjustedNetworth', 'equityShareCapital', 'workingCapitalLimits', 'longTermDebt', 'revenueGrowth', 'operatingProfit', 'profitAfterTax', 'netCashAccruals', 'operatingProfitMargin', 'netProfitMargin', 'netCashAccrualsToSales', 'returnOnNetWorth', 'returnOnCapitalEmployed', 'rawMaterialAsPerOfOpIncome', 'powerFuelCostAsOfOpIncome', 'employeeCostAsPerOfOpIncome', 'sgaExpAsOfOpIncome', 'contributionToNetSales', 'tolTnw', 'gearingRatio', 'debtEbitda', 'shortTermDebtToTotalDebt', 'netCashAccrualsToTotalDebt', 'interestCoverageRatio', 'debtServiceCoverageRatio', 'ratioOfWorkingCapitalLimitsToTurnover', 'currentRatio', 'quickRatio', 'workingCapitalDays', 'grossCurrentAssetsDays', 'debtorsAsDaysGrossSales', 'payablesAsDaysCostOfSales', 'inventoryAsDaysCostOfSales', 'shortTermAssetTurnoverRatio', 'operatingIncomeGrossBlock'];
        $scope.bankDataPoints = ['advances', 'assets', 'growthInFundsDeployed', 'netInterestIncome', 'totalIncome', 'profitAfterTax', 'nimAverageFundsDeployed', 'operatingExpensesAverageFundsDeployed', 'interestEarnedInterestExpended', 'growthInNetInterestIncome', 'roa', 'roe', 'networth', 'casa', 'tier1Ratio', 'tier2Ratio', 'capitalAdequacyRatio', 'tangibleNetWorthNetNpa', 'grossNpaLoansAndAdvances', 'netNpaLoansAndAdvances', 'provisionsAverageFundsDeployed', 'creditDepositRatio'];
        $scope.nbfcDataPoints = ['advances', 'assets', 'growthInFundsDeployed', 'totalInterestIncome', 'totalIncome', 'profitAfterTax', 'interestEarnedInterestExpended', 'nimAverageFundsDeployed', 'operatingExpensesAverageFundsDeployed', 'rpatTotalAssets', 'roe', 'costToIncomeRatio', 'networth', 'tangibleNetWorthNetNpa', 'tier1Ratio', 'tier2Ratio', 'totalDebtReportedNetworth', 'capitalAdequacyRatio', 'grossNpaLoansAndAdvances', 'netNpaLoansAndAdvances', 'provisionsAverageFundsDeployed'];
        $scope.manuDataTableCount = 0;
        $scope.manuGraphCount = 0;
        $scope.bankDataTableCount = 0;
        $scope.bankGraphCount = 0;
        $scope.nbfcDataTableCount = 0;
        $scope.nbfcGraphCount = 0;
        $scope.validGraphCount = false;
        $scope.validCount = true;
        $scope.mcaChargesCount = false;

        if($scope.templateJson.template.peerBenchmarking!=null){
            for(var i = 0; i<$scope.manuDataPoints.length; i++){
                if($scope.templateJson.template.peerBenchmarking.peerComparisionDetailedManu[$scope.manuDataPoints[i]].dataTable){
                    $scope.manuDataTableCount = $scope.manuDataTableCount+1;
                }
                if($scope.templateJson.template.peerBenchmarking.peerComparisionDetailedManu[$scope.manuDataPoints[i]].graph){
                    $scope.manuGraphCount = $scope.manuGraphCount+1;
                }
            }
    
            for(var i = 0; i<$scope.bankDataPoints.length; i++){
                if($scope.templateJson.template.peerBenchmarking.peerComparisionDetailedBanks[$scope.bankDataPoints[i]].dataTable){
                    $scope.bankDataTableCount = $scope.bankDataTableCount+1;
                }
                if($scope.templateJson.template.peerBenchmarking.peerComparisionDetailedBanks[$scope.bankDataPoints[i]].graph){
                    $scope.bankGraphCount = $scope.bankGraphCount+1;
                }
            }
    
            for(var i = 0; i<$scope.nbfcDataPoints.length; i++){
                if($scope.templateJson.template.peerBenchmarking.peerComparisionDetailedNbfc[$scope.nbfcDataPoints[i]].dataTable){
                    $scope.nbfcDataTableCount = $scope.nbfcDataTableCount+1;
                }
                if($scope.templateJson.template.peerBenchmarking.peerComparisionDetailedNbfc[$scope.nbfcDataPoints[i]].graph){
                    $scope.nbfcGraphCount = $scope.nbfcGraphCount+1;
                }
            }
            console.log("Data Table Count Onload: "+$scope.manuDataTableCount);
            console.log("Graph Count Onload: "+$scope.manuGraphCount);
    
            if(($scope.manuGraphCount == 6 || $scope.manuGraphCount == 4) && ($scope.bankGraphCount == 6 || $scope.bankGraphCount == 4) && ($scope.nbfcGraphCount == 6 || $scope.nbfcGraphCount == 4)){
                $scope.validGraphCount = true;
            }
            
            if($scope.manuDataTableCount < 6 || $scope.bankDataTableCount < 6 || $scope.nbfcDataTableCount < 6 || !$scope.validGraphCount){
                $scope.validCount = false;
            }
        }

        $scope.industryAggr = false;
        $scope.excludeSubSections = false;
        $scope.preOrderedTabs = [{
              "id" : 1,
              "paramId" : "companyGroupDetails",
              "paramString" : "Company and Group Overview"
            },
            {
              "id" : 2,
              "paramId" : "financialSelectionDTO",
              "paramString" : "Company Financials"
            }, {
                "id" : 3,
                "paramId" : "ratingDetails",
                "paramString" : "Ratings"
            }, {
                "id" : 4,
                "paramId" : "capitalMarketData",
                "paramString" : "Capital Market data"
            }, {
              "id" : 5,
              "paramId" : "peerBenchmarking",
              "paramString" : "Peer Benchmarking"
            }, {
              "id" : 6,
              "paramId" : "crisilAnalytics",
              "paramString" : "CRISIL Analytics & Outlook"
            },{
              "id" : 7,
              "paramId" : "alternateData",
              "paramString" : "Alternate Data Indicators"
            },{
              "id" : 16,
              "paramId" : "otherKeyFinancialParams",
              "paramString" : "Other Key Financial Parameters"
            },{
              "id" : 15,
              "paramId" : "summarySheet",
              "paramString" : "Summary Sheet"
            },
            {
                "id" : 16,
                "paramId" : "mcaCharges",
                "paramString" : "MCA charges"
              },
              {
                "id" : 17,
                "paramId" : "compWithIndustry",
                "paramString" : "Comparison with Industry"
              }
        ];

        $scope.ifOptionSelected = function(section) {
            return _.find($scope.templateJson.template.ordering, ['paramId', section]) ? true : false;
        }

        $scope.activeTab = '';
        if($scope.ifOptionSelected('companyOverview') || $scope.ifOptionSelected('shareHoldingInformation') || $scope.ifOptionSelected('managementDetails')  || $scope.ifOptionSelected('relatedParties')) {
            $scope.previousTab = $scope.activeTab = 'companyGroupDetails';
        } else if($scope.ifOptionSelected('financialSelectionDTO')) {
            $scope.previousTab = $scope.activeTab = 'financialSelectionDTO';
        } else if($scope.ifOptionSelected('peerBenchmarking')) {
            $scope.previousTab = $scope.activeTab = 'peerBenchmarking';
        } else if($scope.ifOptionSelected('crisilAnalytics') || $scope.ifOptionSelected('crisilOutlook')) {
            $scope.previousTab = $scope.activeTab = 'crisilAnalytics';
        } else if($scope.ifOptionSelected('ratingDetails')) {
            $scope.previousTab = $scope.activeTab = 'ratingDetails';
        } else if($scope.ifOptionSelected('capitalMarketData')) {
            $scope.previousTab = $scope.activeTab = 'capitalMarketData';
        } else if($scope.ifOptionSelected('alternateData')) {
            $scope.previousTab = $scope.activeTab = 'alternateData';
        }
         else if($scope.ifOptionSelected('otherKeyFinancialParams')) {
            $scope.previousTab = $scope.activeTab = 'otherKeyFinancialParams';
            console.log("Inside == otherKeyFinancialParams");
        } else if($scope.ifOptionSelected('summarySheet')) {
             $scope.previousTab = $scope.activeTab = 'summarySheet';
             console.log("Inside == summarySheet");
        } else if($scope.ifOptionSelected('mcaCharges')){
            $scope.previousTab = $scope.activeTab = 'mcaCharges';
            console.log("Inside == mcaCharges");
        }else if($scope.ifOptionSelected('compWithIndustry')){
            console.log("Inside == compWithInd");
            $scope.previousTab = $scope.activeTab = 'compWithIndustry';
        }
        $window.scroll(0,0);

        $scope.initiateParams = function() {
            if($scope.templateJson.template.capitalMarketData) {
                $scope.sharePriceVolumes.fiveDay = $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf('5day') >= 0;
                $scope.sharePriceVolumes.oneMon = $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf('1mon') >= 0;
                $scope.sharePriceVolumes.sixMon = $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf('6mon') >= 0;
                $scope.sharePriceVolumes.oneYr = $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf('1yr') >= 0;
                $scope.sharePriceVolumes.twoYr = $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf('2yr') >= 0;
                $scope.sharePriceVolumes.fiveYr = $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf('5yr') >= 0;
            }
            //paramId != 'companyOverview' && paramId != 'shareHoldingInformation' && paramId != 'managementDetails' && paramId != 'mcaCharges' && paramId != 'relatedParties';
            $scope.excludeSubSections = _.find($scope.templateJson.template.ordering, ['paramId', 'companyOverview']) || _.find($scope.templateJson.template.ordering, ['paramId', 'shareHoldingInformation']) || _.find($scope.templateJson.template.ordering, ['paramId', 'managementDetails'])
                                                || _.find($scope.templateJson.template.ordering, ['paramId', 'mcaCharges']) || _.find($scope.templateJson.template.ordering, ['paramId', 'relatedParties']);
        }
        
        $scope.addMoreSections = function() {
            //localStorage.setItem()
            $state.go('createnewtemplate', {
                templateJson: $scope.templateJson,
                isAdminEdit: $scope.isAdminEdit
            })
        }

        $scope.onParentChange = function(parent) {
            switch(parent) {
                case 'summaryFinancialsParent': 
                    $scope.templateJson.template.financialSelectionDTO.summaryFinancialsStandalone = $scope.templateJson.template.financialSelectionDTO.summaryFinancialsConsolidated = $scope.templateJson.template.financialSelectionDTO.summaryFinancialsQuarterly = $scope.templateJson.template.financialSelectionDTO.summaryFinancialsAnnual = $scope.templateJson.template.financialSelectionDTO.summaryFinancialsConsolidated = $scope.templateJson.template.financialSelectionDTO.summaryFinancialsStandalone =$scope.templateJson.template.financialSelectionDTO.summaryFinancials;
                    if($scope.templateJson.template.financialSelectionDTO.summaryFinancials) 
                        $scope.templateJson.template.financialSelectionDTO.summaryFinancialPeriod = '3';
                    else 
                        $scope.templateJson.template.financialSelectionDTO.summaryFinancialPeriod = undefined;
                    break;
                case 'detailFinancialsParent':
                    $scope.templateJson.template.financialSelectionDTO.detailedFinancialsProfitAndLoss = $scope.templateJson.template.financialSelectionDTO.detailedFinancialsBalanceSheet = $scope.templateJson.template.financialSelectionDTO.detailedFinancialsCashFlow = $scope.templateJson.template.financialSelectionDTO.detailedFinancialsKeyFinancialRatios =$scope.templateJson.template.financialSelectionDTO.detailedFinancialsKeySchedules = $scope.templateJson.template.financialSelectionDTO.moveToAnnexure = $scope.templateJson.template.financialSelectionDTO.detailedFinancialsAnnual = $scope.templateJson.template.financialSelectionDTO.annualIncomeStmt = $scope.templateJson.template.financialSelectionDTO.advances = $scope.templateJson.template.financialSelectionDTO.restructuring = $scope.templateJson.template.financialSelectionDTO.npa = $scope.templateJson.template.financialSelectionDTO.detailedFinancials;
                    if($scope.templateJson.template.financialSelectionDTO.detailsParent != $scope.templateJson.template.financialSelectionDTO.detailedFinancials || $scope.templateJson.template.financialSelectionDTO.detailedQuarterlyFinancials) {
                        $scope.templateJson.template.financialSelectionDTO.detailsParent = $scope.templateJson.template.financialSelectionDTO.detailedFinancials || $scope.templateJson.template.financialSelectionDTO.detailedQuarterlyFinancials;
                    }   
                    break;
                case 'detailFinancials':
                    $scope.templateJson.template.financialSelectionDTO.detailedFinancialsProfitAndLoss = $scope.templateJson.template.financialSelectionDTO.detailedFinancialsBalanceSheet = $scope.templateJson.template.financialSelectionDTO.detailedFinancialsCashFlow = $scope.templateJson.template.financialSelectionDTO.detailedFinancialsKeyFinancialRatios =$scope.templateJson.template.financialSelectionDTO.detailedFinancialsKeySchedules = $scope.templateJson.template.financialSelectionDTO.moveToAnnexure = $scope.templateJson.template.financialSelectionDTO.detailedFinancials = $scope.templateJson.template.financialSelectionDTO.annualIncomeStmt = $scope.templateJson.template.financialSelectionDTO.advances = $scope.templateJson.template.financialSelectionDTO.restructuring = $scope.templateJson.template.financialSelectionDTO.npa = $scope.templateJson.template.financialSelectionDTO.detailedFinancialsAnnual;
                    break;
                case 'detailQuarterlyFinancialsParent':
                    var value = $scope.templateJson.template.financialSelectionDTO.detailedQuarterlyFinancials;
                    $scope.templateJson.template.financialSelectionDTO.detailedFinancialsQuarterly = value;
                    $scope.templateJson.template.financialSelectionDTO.quarterlyIncomeStmt = $scope.templateJson.template.financialSelectionDTO.assetLiabilities = $scope.templateJson.template.financialSelectionDTO.keyRatios = value;
                    if($scope.templateJson.template.financialSelectionDTO.detailsParent != $scope.templateJson.template.financialSelectionDTO.detailedFinancials || $scope.templateJson.template.financialSelectionDTO.detailedQuarterlyFinancials) {
                        $scope.templateJson.template.financialSelectionDTO.detailsParent = $scope.templateJson.template.financialSelectionDTO.detailedFinancials || $scope.templateJson.template.financialSelectionDTO.detailedQuarterlyFinancials;
                    } 
                    break;
                case 'detailQuarterly':
                    var value = $scope.templateJson.template.financialSelectionDTO.detailedFinancialsQuarterly;
                    $scope.templateJson.template.financialSelectionDTO.detailedQuarterlyFinancials = value;
                    $scope.templateJson.template.financialSelectionDTO.quarterlyIncomeStmt = $scope.templateJson.template.financialSelectionDTO.assetLiabilities = $scope.templateJson.template.financialSelectionDTO.keyRatios = value;
                    break;
                case 'mgmtDetails':
                    $scope.templateJson.template.managementDetails.keyManagementPer =  $scope.templateJson.template.managementDetails.boardMembers = $scope.templateJson.template.managementDetails.otherDirectorship = $scope.templateJson.template.managementDetails.auditorDetails = $scope.templateJson.template.managementDetails.applyCrisilDefault = $scope.templateJson.template.managementDetails.mgmtDetails
                    break;
                case 'mca':
                    $scope.templateJson.template.mcaCharges.pendingCharges = $scope.templateJson.template.mcaCharges.satisfiedChanges = $scope.templateJson.template.mcaCharges.applyCrisilDefault = $scope.templateJson.template.mcaCharges.mca;
                    if(!$scope.templateJson.template.mcaCharges.mca) $scope.templateJson.template.mcaCharges.chargePeriod = undefined;
                    break;
                case 'scorecard':
                    $scope.templateJson.template.crisilAnalytics.scorecardParamUniverse = $scope.templateJson.template.crisilAnalytics.scorecardParamSameIndustry = $scope.templateJson.template.crisilAnalytics.companyScoredcard;
                    if(!$scope.templateJson.template.crisilAnalytics.companyScoredcard) $scope.templateJson.template.crisilAnalytics.companyScorecardPeriod = undefined;
                    break;
                case 'peer':
                    $scope.templateJson.template.peerBenchmarking.financialComparison = $scope.templateJson.template.peerBenchmarking.conservativeRatings = $scope.templateJson.template.peerBenchmarking.peerComparison;
                    $scope.templateJson.template.peerBenchmarking.year =  $scope.templateJson.template.peerBenchmarking.financialComparison ? 'commonYear' : undefined;
                    break;
                case 'gstCompliance':
                    $scope.templateJson.template.alternateData.diligenceAnnexure = $scope.templateJson.template.alternateData.gstCompliance;
                    break;
                case 'litigations':
                    $scope.templateJson.template.alternateData.againstCompany = $scope.templateJson.template.alternateData.litigationsAnnexure =  $scope.templateJson.template.alternateData.litigations;
                    break;
                case 'keystock':
                    $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume = [];
                    $scope.sharePriceVolumes.fiveDay = $scope.sharePriceVolumes.oneMon = $scope.sharePriceVolumes.sixMon = $scope.sharePriceVolumes.oneYr = $scope.sharePriceVolumes.twoYr = $scope.sharePriceVolumes.fiveYr = $scope.templateJson.template.capitalMarketData.keyStockIndicator;
                    break;
                case 'rating': 
                    $scope.templateJson.template.ratingDetails.moveToAnnexure = $scope.templateJson.template.ratingDetails.ratingHistory;
                    if(!$scope.templateJson.template.ratingDetails.ratingHistory) $scope.templateJson.template.ratingDetails.ratingHistoryPeriod = undefined;
                    break;
                case 'industryAggr':
                    if(!$scope.templateJson.template.peerBenchmarking.comparisonIndAggDTO.indAggComparison) {
                        $scope.templateJson.template.peerBenchmarking.comparisonIndAggDTO.medianoragg = undefined;
                        $scope.templateJson.template.peerBenchmarking.comparisonIndAggDTO.allorcommon = undefined;
                    }
                    break;
                case 'detailsParent': 
                    $scope.templateJson.template.financialSelectionDTO.detailedFinancialsStandalone = $scope.templateJson.template.financialSelectionDTO.detailedFinancialsConsolidated = $scope.templateJson.template.financialSelectionDTO.detailedFinancials = $scope.templateJson.template.financialSelectionDTO.detailedQuarterlyFinancials = $scope.templateJson.template.financialSelectionDTO.detailsParent;
                    $scope.onParentChange('detailFinancialsParent');
                    $scope.onParentChange('detailQuarterlyFinancialsParent');
                    $scope.templateJson.template.financialSelectionDTO.detailedFinancialsPeriod = $scope.templateJson.template.financialSelectionDTO.detailsParent ? '3' : undefined;
                    break;
                case 'segmentPerform':
                    if ($scope.templateJson.template.otherKeyFinancialParams.segmentPerformance) {
                        $scope.templateJson.template.otherKeyFinancialParams.standalone = true;
                        $scope.templateJson.template.otherKeyFinancialParams.consolidated = true;
                    }else if(!$scope.templateJson.template.otherKeyFinancialParams.segmentPerformance){
                        $scope.templateJson.template.otherKeyFinancialParams.standalone = false;
                        $scope.templateJson.template.otherKeyFinancialParams.consolidated = false;
                    }
                    break;
                case 'epfoContribute':
                    if ($scope.templateJson.template.alternateData.epfoContribution) {
                        $scope.templateJson.template.alternateData.significantDecrease = true;
                        $scope.templateJson.template.alternateData.significantDrop = true;
                        $scope.templateJson.template.alternateData.delayInPaymentOfEPFO = true;
                        $scope.templateJson.template.alternateData.defaultInEPF = true;
                    }else if(!$scope.templateJson.template.alternateData.epfoContribution){
                        $scope.templateJson.template.alternateData.significantDecrease = false;
                        $scope.templateJson.template.alternateData.significantDrop = false;
                        $scope.templateJson.template.alternateData.delayInPaymentOfEPFO = false;
                        $scope.templateJson.template.alternateData.defaultInEPF = false;                        
                    }
                    break;
                case 'dueDiligence':
                    if ($scope.templateJson.template.alternateData.dueDiligence) {
                        $scope.templateJson.template.alternateData.presentInVanishingComp = true;
                        $scope.templateJson.template.alternateData.presentInDefaulterList = true;
                        $scope.templateJson.template.alternateData.sebiDebarredList = true;
                        $scope.templateJson.template.alternateData.companyStruckOffList = true;
                        $scope.templateJson.template.alternateData.lastAGMoverDue = true;
                        $scope.templateJson.template.alternateData.bankruptInsolvant = true;
                        $scope.templateJson.template.alternateData.minPublicHolding = true;
                        $scope.templateJson.template.alternateData.directorPromoterResign = true;
                        $scope.templateJson.template.alternateData.directorsDisqualifiedDefaulters = true;
                        $scope.templateJson.template.alternateData.directorDefaulterDirectors = true;
                    }else if(!$scope.templateJson.template.alternateData.dueDiligence){
                        $scope.templateJson.template.alternateData.presentInVanishingComp = false;
                        $scope.templateJson.template.alternateData.presentInDefaulterList = false;
                        $scope.templateJson.template.alternateData.sebiDebarredList = false;
                        $scope.templateJson.template.alternateData.companyStruckOffList = false;
                        $scope.templateJson.template.alternateData.lastAGMoverDue = false;
                        $scope.templateJson.template.alternateData.bankruptInsolvant = false;
                        $scope.templateJson.template.alternateData.minPublicHolding = false;
                        $scope.templateJson.template.alternateData.directorPromoterResign = false;
                        $scope.templateJson.template.alternateData.directorsDisqualifiedDefaulters = false;
                        $scope.templateJson.template.alternateData.directorDefaulterDirectors = false;
                    }

            }
        }

        $scope.excludeSubSectionsByParamId = function(paramId) {
            switch(paramId) {
                case 'companyGroupDetails':
                    return $scope.ifOptionSelected('companyOverview') || $scope.ifOptionSelected('shareHoldingInformation') || $scope.ifOptionSelected('managementDetails') || $scope.ifOptionSelected('relatedParties');
                case 'crisilAnalytics': 
                    return $scope.showCrisilAnalytics();
                default:
                    return $scope.ifOptionSelected(paramId);
            }
            // var excludeCurrentTab = paramId != 'companyOverview' && paramId != 'shareHoldingInformation' && paramId != 'managementDetails' && paramId != 'mcaCharges' && paramId != 'relatedParties' && paramId != 'crisilOutlook' && paramId != 'crisilAnalytics';
            // return excludeCurrentTab;
        }

        $scope.showCrisilAnalytics = function() {
            return _.find($scope.templateJson.template.ordering, ['paramId', 'crisilOutlook']) || _.find($scope.templateJson.template.ordering, ['paramId', 'crisilAnalytics'])
        }

        $scope.saveTemplate = function() {
            $scope.message = '';
            if($scope.isAdminEdit == 'Y') {
                CompanyReportService.saveTemplateForAdminEdit($scope.templateJson).then(function(response) {
                    console.log(response);
                    $scope.message = response.data;
                    $scope.isError = false;
                    $state.go('companyreport');
                    $timeout(function () {
                        $scope.message = '';
                    }, 5000);
                }, function(error) {
                    $scope.message = error.data;
                    $scope.isError = true;
                    $timeout(function () {
                        $scope.message = '';
                    }, 5000);
                });
            } else if($scope.action == 'edit'){
            	
                CompanyReportService.saveOrEditTemplate($scope.templateJson).then(function(response) {
                    console.log(response);
                    $scope.message = response.data;
                    $scope.isError = false;
                   
                    $timeout(function () {
                        $scope.message = '';
                        $state.go('companyreport');
                    }, 4000);
                  
                }, function(error) {
                    $scope.message = error.data;
                    $scope.isError = true;
                    $timeout(function () {
                        $scope.message = '';
                        $state.go('companyreport');
                    }, 5000);
                });
            }else{
                CompanyReportService.saveTemplate($scope.templateJson).then(function(response) {
                    console.log(response);
                    $scope.message = response.data;
                    $scope.isError = false;
                
                    $timeout(function () {
                        $scope.message = '';
                        $state.go('companyreport');
                    }, 4000);
                  
                }, function(error) {
                    $scope.message = error.data;
                    $scope.isError = true;
                    $timeout(function () {
                        $scope.message = '';
                        $state.go('companyreport');
                    }, 4000);
                });
            }
        }

        $scope.isCrisilOutlookSelected  = function() {
            return _.find($scope.templateJson.template.ordering, ['paramId', 'crisilOutlook']) ? true : false;
        }

        $scope.isCrisilAnalyticsSelected = function() {
            return _.find($scope.templateJson.template.ordering, ['paramId', 'crisilAnalytics']) ? true : false;
        }

        $scope.isElementChecked = function(value) {
            return $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf(value) >= 0;
        }

        $scope.changeSharepriceVolume = function(value) {
            if(!$scope.templateJson.template.capitalMarketData.keyStockIndicator)
                $scope.templateJson.template.capitalMarketData.keyStockIndicator = $scope.sharePriceVolumes.fiveDay || $scope.sharePriceVolumes.oneMon || $scope.sharePriceVolumes.sixMon || $scope.sharePriceVolumes.oneYr || $scope.sharePriceVolumes.twoYr || $scope.sharePriceVolumes.fiveYr
            switch (value) {
                case '5day':
                    $scope.sharePriceVolumes.fiveDay ? $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.push(value) : $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.splice($scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf(value), 1)
                    break;
                case '1mon':
                    $scope.sharePriceVolumes.oneMon ? $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.push(value) : $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.splice($scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf(value), 1)
                    break;
                case '6mon':
                    $scope.sharePriceVolumes.sixMon ? $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.push(value) : $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.splice($scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf(value), 1)
                    break;
                case '1yr':
                    $scope.sharePriceVolumes.oneYr ? $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.push(value) : $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.splice($scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf(value), 1)
                    break;
                case '2yr':
                    $scope.sharePriceVolumes.twoYr ? $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.push(value) : $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.splice($scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf(value), 1)
                    break;
                case '5yr':
                    $scope.sharePriceVolumes.fiveYr ? $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.push(value) : $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.splice($scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf(value), 1)
                    break;
            }
        }

        $scope.closeAlert = function() {
            $scope.message = '';
        }

        $scope.getParamValidation = function(paramId) {
            $scope.peerForm.$invalid;
        }

        
        $scope.shouldDisplayMinSelectionError = function () {
            $scope.mcaChargesCount = $scope.getTotalSelectedCount() <3 || $scope.getTotalSelectedCount() >7;
            return $scope.getTotalSelectedCount() <3;
        };
    
        $scope.shouldDisplayMaxSelectionError = function () {
            $scope.mcaChargesCount = $scope.getTotalSelectedCount() <3 || $scope.getTotalSelectedCount() >7;
            return $scope.getTotalSelectedCount() > 7;
        };
    
        $scope.getTotalSelectedCount = function () {
            var selectedCount = 0;
            
            if ($scope.templateJson.template.mcaCharges.srn) selectedCount++;
            if ($scope.templateJson.template.mcaCharges.chargeId) selectedCount++;
            if ($scope.templateJson.template.mcaCharges.assetsUnderCharge) selectedCount++;
            if ($scope.templateJson.template.mcaCharges.chargeHolderName) selectedCount++;

            if ($scope.templateJson.template.mcaCharges.chargeCreationDate) selectedCount++;
            if ($scope.templateJson.template.mcaCharges.chargeModificationDate) selectedCount++;
            if ($scope.templateJson.template.mcaCharges.chargeSatisfactionDate) selectedCount++;
            if ($scope.templateJson.template.mcaCharges.chargeAmount) selectedCount++;
            if ($scope.templateJson.template.mcaCharges.chargeAddress) selectedCount++;

            return selectedCount;
        };

   
        $scope.isDefined = function(value) {
            switch(value) {
                case 'ytm':
                    return $scope.templateJson.template.capitalMarketData ? angular.isDefined($scope.templateJson.template.capitalMarketData.ytm) : false;
            }
        }

        $scope.initiateParams();

        $scope.closeFormMessage = function() {
            $scope.formMessage = '';
        }
        

        $scope.intervalMessage;
        $scope.show = function (e) {
            if($scope.action != 'view') {
                if(e != $scope.previousTab || e == 'lastTabSave') {
                    $scope.formMessage = $scope.previousTab + ' Form saved successfully';
                    switch ($scope.previousTab) {
                        case 'crisilAnalytics':
                            $scope.formMessage = 'CRISIL Analytics & Outlook saved successfully';
                            $scope.crisilAnalyticsForm.$setSubmitted(true);
                            break;
                        case 'companyGroupDetails':
                            $scope.formMessage = 'Company and Group Overview saved successfully';
                            $scope.companyGroupDetailsForm.$setSubmitted(true);
                            if($scope.templateJson.template.beneficialOwnership) {
                                $scope.formMessage = 'Company and Group Overview along & Visibility of Beneficial Ownership saved successfully';
                            }
                            break;
                        case 'financialSelectionDTO':
                            $scope.formMessage = 'Company Financials saved successfully';
                            $scope.financialSelectionDTOForm.$setSubmitted(true);
                            break;
                        case 'peerBenchmarking':
                            $scope.formMessage = 'Peer benchmarking saved successfully';
                            $scope.peerBenchmarkingForm.$setSubmitted(true);
                            break;
                        case 'capitalMarketData':
                            $scope.formMessage = 'Capital Market data saved successfully';
                            $scope.capitalMarketDataForm.$setSubmitted(true);
                            break;
                        case 'ratingDetails':
                            $scope.formMessage = 'Ratings saved successfully';
                            $scope.ratingDetailsForm.$setSubmitted(true);
                            break;
                        case 'alternateData':
                            $scope.formMessage = 'Alternate Data Indicators saved successfully';
                            $scope.alternateDataForm.$setSubmitted(true);
                            break;
                        case 'otherKeyFinancialParams':
                            $scope.formMessage = 'Other Key Financial Parameters saved successfully';
                            $scope.otherKeyFinancialParamsForm.$setSubmitted(true);
                            break;
                        case 'summarySheet':
                            $scope.formMessage = 'Summary Sheet saved successfully';
                            $scope.summarySheet.$setSubmitted(true);
                            break;
                        case 'compWithIndustry':
                            $scope.formMessage = 'Comparision with Industry saved successfully';
                            $scope.compWithInd.$setSubmitted(true);
                            break;
                    }
                    $scope.templateJson.template.customFormState[$scope.previousTab + 'Submit'] = true;
                    if(e != 'lastTabSave')
                        $scope.previousTab = e;
                    if($scope.intervalMessage) {
                        $timeout.cancel($scope.intervalMessage);
                    }
                    $scope.intervalMessage = $timeout(function () {
                        $scope.formMessage = '';
                    }, 5000);
                }
            }
        }

        $scope.deleteParam = function(paramId) {
            if(paramId == 'crisilAnalytics' || paramId == 'companyGroupDetails') {
                switch (paramId) {
                    case 'crisilAnalytics':
                        $scope.templateJson.template.ordering.splice( _.findIndex($scope.templateJson.template.ordering, ['paramId', paramId]), 1);
                        $scope.templateJson.template.ordering.splice( _.findIndex($scope.templateJson.template.ordering, ['paramId', 'crisilOutlook']), 1);
                        delete $scope.templateJson.template[paramId];
                        delete $scope.templateJson.template['crisilOutlook'];
                        $scope.templateJson.template.customFormState['crisilAnalyticsSubmit'] = false;
                        break;
                    case 'companyGroupDetails':
                        if(_.findIndex($scope.templateJson.template.ordering, ['paramId', 'companyOverview']) >= 0) 
                            $scope.templateJson.template.ordering.splice( _.findIndex($scope.templateJson.template.ordering, ['paramId', 'companyOverview']), 1);
                        if(_.findIndex($scope.templateJson.template.ordering, ['paramId', 'shareHoldingInformation']) >= 0)
                            $scope.templateJson.template.ordering.splice( _.findIndex($scope.templateJson.template.ordering, ['paramId', 'shareHoldingInformation']), 1);
                        if(_.findIndex($scope.templateJson.template.ordering, ['paramId', 'managementDetails']) >= 0)
                            $scope.templateJson.template.ordering.splice( _.findIndex($scope.templateJson.template.ordering, ['paramId', 'managementDetails']), 1);
                        if(_.findIndex($scope.templateJson.template.ordering, ['paramId', 'relatedParties']) >= 0)
                            $scope.templateJson.template.ordering.splice( _.findIndex($scope.templateJson.template.ordering, ['paramId', 'relatedParties']), 1);
                        /** if(_.findIndex($scope.templateJson.template.ordering, ['paramId', 'mcaCharges']) >= 0)
                            $scope.templateJson.template.ordering.splice( _.findIndex($scope.templateJson.template.ordering, ['paramId', 'mcaCharges']), 1); */
                        // _.remove($scope.templateJson.template.ordering, function (n) { return n.id == 'companyOverview' });
                        // _.remove($scope.templateJson.template.ordering, function (n) { return n.id == 'shareHoldingInformation' });
                        // _.remove($scope.templateJson.template.ordering, function (n) { return n.id == 'managementDetails' });
                        // _.remove($scope.templateJson.template.ordering, function (n) { return n.id == 'relatedParties' });
                        // _.remove($scope.templateJson.template.ordering, function (n) { return n.id == 'mcaCharges' });
                        delete $scope.templateJson.template['companyOverview'];
                        delete $scope.templateJson.template['shareHoldingInformation'];
                        delete $scope.templateJson.template['managementDetails'];
                        delete $scope.templateJson.template['relatedParties'];
                        //delete $scope.templateJson.template['mcaCharges'];
                        $scope.excludeSubSections = false;
                        $scope.templateJson.template.customFormState['companyGroupDetailsSubmit'] = false;
                        break;
                }
            } else {
                $scope.templateJson.template.ordering.splice( _.findIndex($scope.templateJson.template.ordering, ['paramId', paramId]), 1);
                delete $scope.templateJson.template[paramId];
                $scope.templateJson.template.customFormState[paramId + 'Submit'] = false;
            }
            if($scope.templateJson.template.ordering.length == 0 || ($scope.templateJson.template.ordering.length == 1 && $scope.templateJson.template.ordering[0].paramId == 'summarySheet')) {
                $state.go('createnewtemplate');
            }
            if($scope.templateJson.template.ordering.length == 0 || ($scope.templateJson.template.ordering.length == 1 && $scope.templateJson.template.ordering[0].paramId == 'compWithInd')) {
                $state.go('createnewtemplate');
            }
        } 

        $scope.setFormStates = function () {
            if($scope.templateJson.template.customFormState.crisilAnalyticsSubmit)
                  $scope.crisilAnalyticsForm.$setSubmitted($scope.templateJson.template.customFormState.crisilAnalyticsSubmit);
            if($scope.templateJson.template.customFormState.companyGroupDetailsSubmit)
                  $scope.companyGroupDetailsForm.$setSubmitted($scope.templateJson.template.customFormState.companyGroupDetailsSubmit);
            if($scope.templateJson.template.customFormState.financialSelectionDTOSubmit)
                  $scope.financialSelectionDTOForm.$setSubmitted($scope.templateJson.template.customFormState.financialSelectionDTOSubmit);
            if($scope.templateJson.template.customFormState.peerBenchmarkingSubmit)
                  $scope.peerBenchmarkingForm.$setSubmitted($scope.templateJson.template.customFormState.peerBenchmarkingSubmit);
            if($scope.templateJson.template.customFormState.capitalMarketDataSubmit)
                  $scope.capitalMarketDataForm.$setSubmitted($scope.templateJson.template.customFormState.capitalMarketDataSubmit);
            if($scope.templateJson.template.customFormState.ratingDetailsSubmit)
                  $scope.ratingDetailsForm.$setSubmitted($scope.templateJson.template.customFormState.ratingDetailsSubmit);
            if($scope.templateJson.template.customFormState.alternateDataSubmit)
                  $scope.alternateDataForm.$setSubmitted($scope.templateJson.template.customFormState.alternateDataSubmit);
            if($scope.templateJson.template.customFormState.otherKeyFinancialParamsSubmit)
                  $scope.otherKeyFinancialParamsForm.$setSubmitted($scope.templateJson.template.customFormState.otherKeyFinancialParamsSubmit);
            if($scope.templateJson.template.customFormState.mcaChargesSubmit)
                  $scope.mcaChargesDetailsForm.$setSubmitted($scope.templateJson.template.customFormState.mcaChargesSubmit);
        }

        $scope.onChildChange = function(param) {
            switch (param) {
                case 'scorecard':
                    if (!$scope.templateJson.template.crisilAnalytics.companyScoredcard)
                        $scope.templateJson.template.crisilAnalytics.companyScoredcard = $scope.templateJson.template.crisilAnalytics.scorecardParamUniverse || $scope.templateJson.template.crisilAnalytics.scorecardParamSameIndustry;
                    break;
                case 'peer':
                    if (!$scope.templateJson.template.peerBenchmarking.peerComparison)
                        $scope.templateJson.template.peerBenchmarking.peerComparison = $scope.templateJson.template.peerBenchmarking.financialComparison || $scope.templateJson.template.peerBenchmarking.conservativeRatings;
                    $scope.templateJson.template.peerBenchmarking.year =  $scope.templateJson.template.peerBenchmarking.financialComparison ? 'commonYear' : undefined;
                    break;
                case 'litigations':
                    if (!$scope.templateJson.template.alternateData.litigations)
                        $scope.templateJson.template.alternateData.litigations = $scope.templateJson.template.alternateData.litigationsAnnexure =$scope.templateJson.template.alternateData.againstCompany;
                    break;
                case 'mca':
                    if (!$scope.templateJson.template.mcaCharges.mca)
                        $scope.templateJson.template.mcaCharges.mca = $scope.templateJson.template.mcaCharges.applyCrisilDefault = $scope.templateJson.template.mcaCharges.pendingCharges || $scope.templateJson.template.mcaCharges.satisfiedChanges;
                    break;
                case 'mgmtDetails':
                    if (!$scope.templateJson.template.managementDetails.mgmtDetails) {
                        $scope.templateJson.template.managementDetails.mgmtDetails = $scope.templateJson.template.managementDetails.applyCrisilDefault = $scope.templateJson.template.managementDetails.keyManagementPer || $scope.templateJson.template.managementDetails.boardMembers || $scope.templateJson.template.managementDetails.otherDirectorship || $scope.templateJson.template.managementDetails.auditorDetails;
                    }
                    break;
                case 'otherDirectorship':
                    if (!$scope.templateJson.template.managementDetails.mgmtDetails) {
                        $scope.templateJson.template.managementDetails.mgmtDetails = $scope.templateJson.template.managementDetails.applyCrisilDefault = $scope.templateJson.template.managementDetails.keyManagementPer || $scope.templateJson.template.managementDetails.boardMembers || $scope.templateJson.template.managementDetails.otherDirectorship || $scope.templateJson.template.managementDetails.auditorDetails;
                    }
                    $scope.templateJson.template.managementDetails.applyCrisilDefault = $scope.templateJson.template.managementDetails.otherDirectorship;
                    break;
                case 'detailFinancials':
                    if (!$scope.templateJson.template.financialSelectionDTO.detailedFinancials)
                        $scope.templateJson.template.financialSelectionDTO.detailedFinancials = $scope.templateJson.template.financialSelectionDTO.detailedFinancialsAnnual = $scope.templateJson.template.financialSelectionDTO.moveToAnnexure = $scope.templateJson.template.financialSelectionDTO.detailedFinancialsProfitAndLoss || $scope.templateJson.template.financialSelectionDTO.detailedFinancialsBalanceSheet || $scope.templateJson.template.financialSelectionDTO.detailedFinancialsCashFlow || $scope.templateJson.template.financialSelectionDTO.detailedFinancialsKeyFinancialRatios || $scope.templateJson.template.financialSelectionDTO.detailedFinancialsKeySchedules || $scope.templateJson.template.financialSelectionDTO.detailedFinancialsStandalone || $scope.templateJson.template.financialSelectionDTO.detailedFinancialsConsolidated || $scope.templateJson.template.financialSelectionDTO.detailedFinancialsAnnual || $scope.templateJson.template.financialSelectionDTO.detailedFinancialsQuarterly || $scope.templateJson.template.financialSelectionDTO.annualIncomeStmt || $scope.templateJson.template.financialSelectionDTO.advances || $scope.templateJson.template.financialSelectionDTO.restructuring || $scope.templateJson.template.financialSelectionDTO.npa;
                    if($scope.templateJson.template.financialSelectionDTO.detailsParent != $scope.templateJson.template.financialSelectionDTO.detailedFinancials || $scope.templateJson.template.financialSelectionDTO.detailedQuarterlyFinancials) {
                        $scope.templateJson.template.financialSelectionDTO.detailsParent = $scope.templateJson.template.financialSelectionDTO.detailedFinancials || $scope.templateJson.template.financialSelectionDTO.detailedQuarterlyFinancials;
                    } 
                    break;
                case 'detailFinancialsQuarterly':
                    $scope.templateJson.template.financialSelectionDTO.detailedQuarterlyFinancials = $scope.templateJson.template.financialSelectionDTO.detailedFinancialsQuarterly = $scope.templateJson.template.financialSelectionDTO.quarterlyIncomeStmt || $scope.templateJson.template.financialSelectionDTO.assetLiabilities || $scope.templateJson.template.financialSelectionDTO.keyRatios;
                    if($scope.templateJson.template.financialSelectionDTO.detailsParent != $scope.templateJson.template.financialSelectionDTO.detailedFinancials || $scope.templateJson.template.financialSelectionDTO.detailedQuarterlyFinancials) {
                        $scope.templateJson.template.financialSelectionDTO.detailsParent = $scope.templateJson.template.financialSelectionDTO.detailedFinancials || $scope.templateJson.template.financialSelectionDTO.detailedQuarterlyFinancials;
                    } 
                    break;
                case 'summaryFinancials':
                    if (!$scope.templateJson.template.financialSelectionDTO.summaryFinancials)
                        $scope.templateJson.template.financialSelectionDTO.summaryFinancials = $scope.templateJson.template.financialSelectionDTO.summaryFinancialsStandalone || $scope.templateJson.template.financialSelectionDTO.summaryFinancialsConsolidated || $scope.templateJson.template.financialSelectionDTO.summaryFinancialsAnnual || $scope.templateJson.template.financialSelectionDTO.summaryFinancialsQuarterly;
                    break;
                case 'rating':
                    if (!$scope.templateJson.template.ratingDetails.ratingHistory)
                        $scope.templateJson.template.ratingDetails.ratingHistory = true;
                    break;
                case 'indAggr':
                    if(!$scope.templateJson.template.peerBenchmarking.comparisonIndAggDTO.indAggComparison)
                        $scope.templateJson.template.peerBenchmarking.comparisonIndAggDTO.indAggComparison = true;
                    break;
                case 'finParameters':
                    $scope.templateJson.template.otherKeyFinancialParams.segmentPerformance = $scope.templateJson.template.otherKeyFinancialParams.standalone || $scope.templateJson.template.otherKeyFinancialParams.consolidated;
                    break;
                case 'epfoCotributionCheck':
                    $scope.templateJson.template.alternateData.epfoContribution =
                    $scope.templateJson.template.alternateData.significantDecrease ||
                    $scope.templateJson.template.alternateData.significantDrop ||
                    $scope.templateJson.template.alternateData.delayInPaymentOfEPFO ||
                    $scope.templateJson.template.alternateData.defaultInEPF;
                    // Check if all child checkboxes are false
                    var allChildCheckboxesFalse =
                        !$scope.templateJson.template.alternateData.significantDecrease &&
                        !$scope.templateJson.template.alternateData.significantDrop &&
                        !$scope.templateJson.template.alternateData.delayInPaymentOfEPFO &&
                        !$scope.templateJson.template.alternateData.defaultInEPF;
                    // Set parent checkbox based on the condition
                    $scope.templateJson.template.alternateData.epfoContribution = !allChildCheckboxesFalse;
                    break;                
                case 'dueDiligenceCheck':                              
                    $scope.templateJson.template.alternateData.dueDiligence =
                        $scope.templateJson.template.alternateData.presentInVanishingComp ||
                        $scope.templateJson.template.alternateData.presentInDefaulterList ||
                        $scope.templateJson.template.alternateData.sebiDebarredList ||
                        $scope.templateJson.template.alternateData.companyStruckOffList ||
                        $scope.templateJson.template.alternateData.lastAGMoverDue ||
                        $scope.templateJson.template.alternateData.bankruptInsolvant ||
                        $scope.templateJson.template.alternateData.minPublicHolding ||
                        $scope.templateJson.template.alternateData.directorPromoterResign ||
                        $scope.templateJson.template.alternateData.directorsDisqualifiedDefaulters ||
                        $scope.templateJson.template.alternateData.directorDefaulterDirectors;                
                    // Check if all child checkboxes are false
                    var allChildCheckboxesFalse =
                        !$scope.templateJson.template.alternateData.presentInVanishingComp &&
                        !$scope.templateJson.template.alternateData.presentInDefaulterList &&
                        !$scope.templateJson.template.alternateData.sebiDebarredList &&
                        !$scope.templateJson.template.alternateData.companyStruckOffList &&
                        !$scope.templateJson.template.alternateData.lastAGMoverDue &&
                        !$scope.templateJson.template.alternateData.bankruptInsolvant &&
                        !$scope.templateJson.template.alternateData.minPublicHolding &&
                        !$scope.templateJson.template.alternateData.directorPromoterResign &&
                        !$scope.templateJson.template.alternateData.directorsDisqualifiedDefaulters &&
                        !$scope.templateJson.template.alternateData.directorDefaulterDirectors;                
                    // Set parent checkbox based on the condition
                    $scope.templateJson.template.alternateData.dueDiligence = !allChildCheckboxesFalse;                
                    break;
            }
        }

        $scope.goToHome = function() {
            $state.go('companyreport');
        }

        $scope.resetCurrentTab = function() {
            switch ($scope.previousTab) {
                case 'crisilAnalytics':
                    if($scope.templateJson.template.crisilAnalytics) {
                        $scope.templateJson.template.crisilAnalytics.fsm = false;
                        $scope.templateJson.template.crisilAnalytics.irs = false;
                        $scope.templateJson.template.crisilAnalytics.companyScoredcard = false;
                        $scope.onParentChange('scorecard');
                    }
                    if(angular.isDefined($scope.templateJson.template.industryOutlook))
                        $scope.templateJson.template.industryOutlook = false;
                    if(angular.isDefined($scope.templateJson.template.economyOutlook))
                        $scope.templateJson.template.economyOutlook = false;
                    break;
                case 'companyGroupDetails':
                    if(angular.isDefined($scope.templateJson.template.managementDetails)) {
                        $scope.templateJson.template.managementDetails.mgmtDetails = false;
                        $scope.onParentChange('mgmtDetails');
                    }
                    if(angular.isDefined($scope.templateJson.template.mcaCharges)) {
                        $scope.templateJson.template.mcaCharges.mca = false;
                        $scope.onParentChange('mca');
                    }
                    break;
                case 'financialSelectionDTO':
                    $scope.templateJson.template.financialSelectionDTO.summaryFinancials = false;
                    $scope.templateJson.template.financialSelectionDTO.detailedFinancials = false;
                    $scope.templateJson.template.financialSelectionDTO.detailedQuarterlyFinancials = false;
                    $scope.templateJson.template.financialSelectionDTO.detailedFinancialsPeriod = undefined;
                    $scope.templateJson.template.financialSelectionDTO.summaryFinancialPeriod = undefined;
                    $scope.templateJson.template.financialSelectionDTO.detailedFinancialsStandalone = $scope.templateJson.template.financialSelectionDTO.detailedFinancialsConsolidated = false;
                    $scope.onParentChange('summaryFinancialsParent');
                    $scope.onParentChange('detailFinancialsParent');
                    $scope.onParentChange('detailQuarterlyFinancialsParent');
                    break;
                case 'peerBenchmarking':
                    $scope.templateJson.template.peerBenchmarking.peerComparison = false;
                    $scope.onParentChange('peer');
                    $scope.templateJson.template.peerBenchmarking.comparisonIndAggDTO.indAggComparison = false;
                    $scope.onParentChange('industryAggr');
                    //$scope.templateJson.template.peerBenchmarking.conductOfTermLoan = false; 
                    break;
                case 'capitalMarketData':
                    $scope.templateJson.template.capitalMarketData.keyStockIndicator = false;
                    $scope.templateJson.template.capitalMarketData.debtIssuance = false;
                    $scope.templateJson.template.capitalMarketData.cpIssuance = false;
                    $scope.templateJson.template.capitalMarketData.bulkAndBlock = false;
                    $scope.templateJson.template.capitalMarketData.ytm = false;
                    $scope.onParentChange('keystock');
                    break;
                case 'ratingDetails':
                    $scope.templateJson.template.ratingDetails.outstandingRating = false;
                    $scope.templateJson.template.ratingDetails.instrumentRating = false;
                    $scope.templateJson.template.ratingDetails.ratingDrivers = false;
                    $scope.templateJson.template.ratingDetails.bankerDetails = false;
                    $scope.templateJson.template.ratingDetails.ratingHistory = false;
                    $scope.onParentChange('rating');
                    break;
                case 'alternateData':
                    $scope.templateJson.template.alternateData.epfoContribution = false;
                    $scope.templateJson.template.alternateData.dueDiligence = false;
                    $scope.templateJson.template.alternateData.litigations = false;
                    $scope.templateJson.template.alternateData.gstCompliance = false;
                    $scope.onParentChange('gstCompliance');
                    $scope.onParentChange('litigations');                    
                    break;
                case 'otherKeyFinancialParams':
                    $scope.templateJson.template.otherKeyFinancialParams.statutoryDues = false;
            }
        }

        $scope.isAnyFormNotSubmitted = function() {
            var ifFormNotSubmit = false;
            for (var index = 0; index < $scope.templateJson.template.ordering.length; index++) {
                const element = $scope.templateJson.template.ordering[index].paramId;
                if(element == 'companyOverview' || element == 'shareHoldingInformation' || element == 'managementDetails' || element == 'relatedParties') {
                    ifFormNotSubmit = ifFormNotSubmit || !$scope.companyGroupDetailsForm.$submitted;
                } else if(element == 'crisilAnalytics' || element == 'crisilOutlook') {
                    ifFormNotSubmit = ifFormNotSubmit || !$scope.crisilAnalyticsForm.$submitted;
                } else {
                    ifFormNotSubmit = ifFormNotSubmit || !$scope[element + 'Form'].$submitted;
                }
            }
            return ifFormNotSubmit;
        }

        $scope.applyCrisilDefault = function() {
            $scope.defaultJson = JSON.parse(localStorage.getItem('defJson'));
            switch ($scope.previousTab) {
                case 'crisilAnalytics':
                    if($scope.templateJson.template.crisilAnalytics) {
                        $scope.templateJson.template.crisilAnalytics = $scope.defaultJson.template.crisilAnalytics;
                    }
                    if($scope.ifOptionSelected('crisilOutlook')) {
                        $scope.templateJson.template.industryOutlook = $scope.defaultJson.template.industryOutlook;
                        $scope.templateJson.template.economyOutlook = $scope.defaultJson.template.economyOutlook;
                    }
                    break;
                case 'companyGroupDetails':
                    if(angular.isDefined($scope.templateJson.template.managementDetails)) {
                        $scope.templateJson.template.managementDetails = $scope.defaultJson.template.managementDetails
                    }
                    break;
                case 'financialSelectionDTO':
                    $scope.templateJson.template.financialSelectionDTO = $scope.defaultJson.template.financialSelectionDTO;
                    break;
                case 'peerBenchmarking':
                    $scope.templateJson.template.peerBenchmarking = $scope.defaultJson.template.peerBenchmarking;
                    break;
                case 'capitalMarketData':
                    $scope.templateJson.template.capitalMarketData = $scope.defaultJson.template.capitalMarketData;
                    $scope.sharePriceVolumes.fiveDay = $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf('5day') >= 0;
                    $scope.sharePriceVolumes.oneMon = $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf('1mon') >= 0;
                    $scope.sharePriceVolumes.sixMon = $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf('6mon') >= 0;
                    $scope.sharePriceVolumes.oneYr = $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf('1yr') >= 0;
                    $scope.sharePriceVolumes.twoYr = $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf('2yr') >= 0;
                    $scope.sharePriceVolumes.fiveYr = $scope.templateJson.template.capitalMarketData.sharePriceReturnsVolume.indexOf('5yr') >= 0;
                    break;
                case 'ratingDetails':
                    $scope.templateJson.template.ratingDetails = $scope.defaultJson.template.ratingDetails;
                    break;
                case 'alternateData':
                    $scope.templateJson.template.alternateData = $scope.defaultJson.template.alternateData;
                    break;
                case 'otherKeyFinancialParams':
                    $scope.templateJson.template.otherKeyFinancialParams.statutoryDues = $scope.defaultJson.template.otherKeyFinancialParams.statutoryDues;
                    break;
                case 'mcaCharges':
                    if(angular.isDefined($scope.templateJson.template.mcaCharges)) {
                        $scope.templateJson.template.mcaCharges = $scope.defaultJson.template.mcaCharges;
                    }
                    break;
            }
        }

        $scope.onDataTableChange = function(section) {
            console.log("Section: ",section);
            console.log("Selected Ratio: ", $scope.data.selectedOption);

            if($scope.data.selectedOption == 'manu'){
                if(!$scope.templateJson.template.peerBenchmarking.peerComparisionDetailedManu[section].dataTable){
                    $scope.templateJson.template.peerBenchmarking.peerComparisionDetailedManu[section].graph = false;
                }
                $scope.onManuValidation();
            }
            else if($scope.data.selectedOption=='bank'){
                if(!$scope.templateJson.template.peerBenchmarking.peerComparisionDetailedBanks[section].dataTable){
                    $scope.templateJson.template.peerBenchmarking.peerComparisionDetailedBanks[section].graph = false;
                }
                $scope.onBankValidation();
            }
            else{
                if(!$scope.templateJson.template.peerBenchmarking.peerComparisionDetailedNbfc[section].dataTable){
                    $scope.templateJson.template.peerBenchmarking.peerComparisionDetailedNbfc[section].graph = false;
                }
                $scope.onNbfcValidation();
            }
        }

        $scope.onGraphChange = function(section) {
            if($scope.data.selectedOption=='manu'){
                if($scope.templateJson.template.peerBenchmarking.peerComparisionDetailedManu[section].graph){
                    $scope.templateJson.template.peerBenchmarking.peerComparisionDetailedManu[section].dataTable = true;
                }
                $scope.onManuValidation();
            }
            else if($scope.data.selectedOption=='bank'){
                if($scope.templateJson.template.peerBenchmarking.peerComparisionDetailedBanks[section].graph){
                    $scope.templateJson.template.peerBenchmarking.peerComparisionDetailedBanks[section].dataTable = true;
                }
                $scope.onBankValidation();
            }
            else{
                if($scope.templateJson.template.peerBenchmarking.peerComparisionDetailedNbfc[section].graph){
                    $scope.templateJson.template.peerBenchmarking.peerComparisionDetailedNbfc[section].dataTable = true;
                }
                $scope.onNbfcValidation();
            }
        }

        $scope.onManuValidation = function() {
            $scope.manuDataTableCount = 0;
            $scope.manuGraphCount = 0;
            for(var i = 0; i<$scope.manuDataPoints.length; i++){
                if($scope.templateJson.template.peerBenchmarking.peerComparisionDetailedManu[$scope.manuDataPoints[i]].dataTable){
                    $scope.manuDataTableCount = $scope.manuDataTableCount+1;
                }
                if($scope.templateJson.template.peerBenchmarking.peerComparisionDetailedManu[$scope.manuDataPoints[i]].graph){
                    $scope.manuGraphCount = $scope.manuGraphCount+1;
                }
            }
            $scope.validateGraphAndDataTable();
        }

        $scope.onBankValidation = function() {
            $scope.bankDataTableCount = 0;
            $scope.bankGraphCount = 0;
            for(var i = 0; i<$scope.bankDataPoints.length; i++){
                if($scope.templateJson.template.peerBenchmarking.peerComparisionDetailedBanks[$scope.bankDataPoints[i]].dataTable){
                    $scope.bankDataTableCount = $scope.bankDataTableCount+1;
                }
                if($scope.templateJson.template.peerBenchmarking.peerComparisionDetailedBanks[$scope.bankDataPoints[i]].graph){
                    $scope.bankGraphCount = $scope.bankGraphCount+1;
                }
            }
            $scope.validateGraphAndDataTable();
        }

        $scope.onNbfcValidation = function() {
            $scope.nbfcDataTableCount = 0;
            $scope.nbfcGraphCount = 0;
            for(var i = 0; i<$scope.nbfcDataPoints.length; i++){
                if($scope.templateJson.template.peerBenchmarking.peerComparisionDetailedNbfc[$scope.nbfcDataPoints[i]].dataTable){
                    $scope.nbfcDataTableCount = $scope.nbfcDataTableCount+1;
                }
                if($scope.templateJson.template.peerBenchmarking.peerComparisionDetailedNbfc[$scope.nbfcDataPoints[i]].graph){
                    $scope.nbfcGraphCount = $scope.nbfcGraphCount+1;
                }
            }
            $scope.validateGraphAndDataTable();
        }

        $scope.validateGraphAndDataTable = function() {
            if(($scope.manuGraphCount == 6 || $scope.manuGraphCount == 4) && ($scope.bankGraphCount == 6 || $scope.bankGraphCount == 4) && ($scope.nbfcGraphCount == 6 || $scope.nbfcGraphCount == 4)){
                $scope.validGraphCount = true;
            }
            else{
                $scope.validGraphCount = false;
            }
            console.log("validGraphCount After: ", $scope.validGraphCount);
            if($scope.manuDataTableCount < 6 || $scope.bankDataTableCount < 6 || $scope.nbfcDataTableCount < 6 || !$scope.validGraphCount){
                $scope.validCount = false;
            }
            else{
                $scope.validCount = true;
            }
            console.log("validCount After: ", $scope.validCount);
        }
        
        $scope.$on('$destroy', function() {
            localStorage.removeItem('defJson')

        });

        // $scope.hasAccess = function(acessField) {
        //     console.log(acessField)
        //     return angular.isDefined($scope.templateJson.template.crisilAnalytics.fsm);
        //     switch (key) {
        //         case 'fsm':
                    
        //             break;
            
        //         default:
        //             break;
        //     }
        // }
    }
})();